import React from 'react';
import { Box, Button, Paper, Typography } from '@mui/material';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import LockRoundedIcon from '@mui/icons-material/LockRounded';
import ConstructionRoundedIcon from '@mui/icons-material/ConstructionRounded';
import InboxRoundedIcon from '@mui/icons-material/InboxRounded';
import { colors, layout, radius } from '../design-system/tokens';

const ICONS = {
  stable: CheckRoundedIcon,
  denied: LockRoundedIcon,
  preparing: ConstructionRoundedIcon,
  empty: InboxRoundedIcon,
};

const TONES = {
  stable: colors.status.success,
  denied: colors.status.danger,
  preparing: colors.status.info,
  empty: colors.status.neutral,
};

const EmptyOperationalState = ({
  variant = 'empty',
  title,
  description,
  actionLabel,
  onAction,
}) => {
  const Icon = ICONS[variant] || ICONS.empty;
  const tone = TONES[variant] || TONES.empty;

  return (
    <Paper
      sx={{
        width: '100%',
        maxWidth: 520,
        mx: 'auto',
        p: { xs: 3, sm: layout.cardPadding + 2 },
        textAlign: 'center',
        borderRadius: `${radius.md}px`,
      }}
    >
      <Box
        sx={{
          width: 38,
          height: 38,
          mx: 'auto',
          mb: 1.5,
          borderRadius: `${radius.pill}px`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: tone.bg,
          color: tone.fg,
          border: `1px solid ${tone.border || colors.border.soft}`,
        }}
      >
        <Icon fontSize="small" />
      </Box>
      <Typography variant="subtitle2" sx={{ fontSize: 15, mb: 0.75, overflowWrap: 'anywhere' }}>
        {title}
      </Typography>
      {description && (
        <Typography
          variant="body2"
          sx={{ color: colors.text.secondary, maxWidth: 400, mx: 'auto', overflowWrap: 'anywhere' }}
        >
          {description}
        </Typography>
      )}
      {actionLabel && onAction && (
        <Button variant="contained" onClick={onAction} sx={{ mt: 2 }}>
          {actionLabel}
        </Button>
      )}
    </Paper>
  );
};

export default EmptyOperationalState;
